function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", "false");

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

// Shopify editor
function editorShopifyEvent(t, e, i) {
  let n = !1;
  t.type.includes("shopify:section")
    ? e.hasAttribute("data-section-id") &&
      e.getAttribute("data-section-id") === t.detail.sectionId &&
      (n = !0)
    : t.type.includes("shopify:block") && t.target === e && (n = !0),
    n && i(t);
}

// Shopify Currency Symbol
const currencySymbol = {
  AED: "د.إ",
  AFN: "؋",
  ALL: "L",
  AMD: "֏",
  ANG: "ƒ",
  AOA: "Kz",
  ARS: "$",
  AUD: "$",
  AWG: "ƒ",
  AZN: "₼",
  BAM: "KM",
  BBD: "$",
  BDT: "Tk",
  BGN: "лв",
  BHD: ".د.ب",
  BIF: "FBu",
  BMD: "$",
  BND: "$",
  BOB: "$b",
  BOV: "BOV",
  BRL: "R$",
  BSD: "$",
  BTC: "₿",
  BTN: "Nu.",
  BWP: "P",
  BYN: "Br",
  BYR: "Br",
  BZD: "BZ$",
  CAD: "$",
  CDF: "FC",
  CHE: "CHE",
  CHF: "CHF",
  CHW: "CHW",
  CLF: "CLF",
  CLP: "$",
  CNY: "¥",
  COP: "$",
  COU: "COU",
  CRC: "₡",
  CUC: "$",
  CUP: "₱",
  CVE: "$",
  CZK: "Kč",
  DJF: "Fdj",
  DKK: "kr",
  DOP: "RD$",
  DZD: "دج",
  EEK: "kr",
  EGP: "£",
  ERN: "Nfk",
  ETB: "Br",
  ETH: "Ξ",
  EUR: "€",
  FJD: "$",
  FKP: "£",
  GBP: "£",
  GEL: "₾",
  GGP: "£",
  GHC: "₵",
  GHS: "GH₵",
  GIP: "£",
  GMD: "D",
  GNF: "FG",
  GTQ: "Q",
  GYD: "$",
  HKD: "$",
  HNL: "L",
  HRK: "kn",
  HTG: "G",
  HUF: "Ft",
  IDR: "Rp",
  ILS: "₪",
  IMP: "£",
  INR: "₹",
  IQD: "ع.د",
  IRR: "﷼",
  ISK: "kr",
  JEP: "£",
  JMD: "J$",
  JOD: "JD",
  JPY: "¥",
  KES: "KSh",
  KGS: "лв",
  KHR: "៛",
  KMF: "CF",
  KPW: "₩",
  KRW: "₩",
  KWD: "KD",
  KYD: "$",
  KZT: "₸",
  LAK: "₭",
  LBP: "£",
  LKR: "₨",
  LRD: "$",
  LSL: "M",
  LTC: "Ł",
  LTL: "Lt",
  LVL: "Ls",
  LYD: "LD",
  MAD: "MAD",
  MDL: "lei",
  MGA: "Ar",
  MKD: "ден",
  MMK: "K",
  MNT: "₮",
  MOP: "MOP$",
  MRO: "UM",
  MRU: "UM",
  MUR: "₨",
  MVR: "Rf",
  MWK: "MK",
  MXN: "$",
  MXV: "MXV",
  MYR: "RM",
  MZN: "MT",
  NAD: "$",
  NGN: "₦",
  NIO: "C$",
  NOK: "kr",
  NPR: "₨",
  NZD: "$",
  OMR: "﷼",
  PAB: "B/.",
  PEN: "S/.",
  PGK: "K",
  PHP: "₱",
  PKR: "₨",
  PLN: "zł",
  PYG: "Gs",
  QAR: "﷼",
  RMB: "￥",
  RON: "lei",
  RSD: "Дин.",
  RUB: "₽",
  RWF: "R₣",
  SAR: "﷼",
  SBD: "$",
  SCR: "₨",
  SDG: "ج.س.",
  SEK: "kr",
  SGD: "S$",
  SHP: "£",
  SLL: "Le",
  SOS: "S",
  SRD: "$",
  SSP: "£",
  STD: "Db",
  STN: "Db",
  SVC: "$",
  SYP: "£",
  SZL: "E",
  THB: "฿",
  TJS: "SM",
  TMT: "T",
  TND: "د.ت",
  TOP: "T$",
  TRL: "₤",
  TRY: "₺",
  TTD: "TT$",
  TVD: "$",
  TWD: "NT$",
  TZS: "TSh",
  UAH: "₴",
  UGX: "USh",
  USD: "$",
  UYI: "UYI",
  UYU: "$U",
  UYW: "UYW",
  UZS: "лв",
  VEF: "Bs",
  VES: "Bs.S",
  VND: "₫",
  VUV: "VT",
  WST: "WS$",
  XAF: "FCFA",
  XBT: "Ƀ",
  XCD: "$",
  XOF: "CFA",
  XPF: "₣",
  XSU: "Sucre",
  XUA: "XUA",
  YER: "﷼",
  ZAR: "R",
  ZMW: "ZK",
  ZWD: "Z$",
  ZWL: "$",
};
const shopCurrencySymbol = currencySymbol[Shopify.currency.active];

/* Get Sibling */
const getSiblings = function (elem) {
  const siblings = [];
  let sibling = elem.parentNode.firstChild;
  while (sibling) {
    if (sibling.nodeType === 1 && sibling !== elem) {
      siblings.push(sibling);
    }
    sibling = sibling.nextSibling;
  }
  return siblings;
};

/* Slide Up */
const slideUp = (target, time) => {
  const duration = time ? time : 500;
  target.style.transitionProperty = "height, margin";
  target.style.transitionDuration = duration + "ms";
  target.style.boxSizing = "border-box";
  target.style.height = target.offsetHeight + "px";
  target.offsetHeight;
  target.style.overflow = "hidden";
  target.style.height = 0;
  window.setTimeout(() => {
    target.style.display = "none";
    target.style.removeProperty("height");
    target.style.removeProperty("overflow");
    target.style.removeProperty("transition-duration");
    target.style.removeProperty("transition-property");
  }, duration);
};
/* Slide Down */
const slideDown = (target, time) => {
  let duration = time ? time : 500;
  target.style.removeProperty("display");
  let display = window.getComputedStyle(target).display;
  if (display === "none") display = "block";
  target.style.display = display;
  const height = target.offsetHeight;
  target.style.overflow = "hidden";
  target.style.height = 0;
  target.offsetHeight;
  target.style.boxSizing = "border-box";
  target.style.transitionProperty = "height, margin";
  target.style.transitionDuration = duration + "ms";
  target.style.height = height + "px";
  window.setTimeout(() => {
    target.style.removeProperty("height");
    target.style.removeProperty("overflow");
    target.style.removeProperty("transition-duration");
    target.style.removeProperty("transition-property");
  }, duration);
};

// Get window top offset
function TopOffset(el) {
  let rect = el.getBoundingClientRect(),
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return { top: rect.top + scrollTop };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class DataCountdown extends HTMLElement {
  constructor() {
    super();

    this.onCountDown();
  }

  onCountDown() {
    const CountDownElement = this.querySelector("[data-countdown]");

    const countDownItem = (value, label) => {
      return `<div class="countdown-item ${label}"><div class="countdown__inner"><span class="countdown__digit">${value}</span> <span class="countdown__labels">${label}</span></div></div>`;
    };
    const date = new Date(
        CountDownElement.getAttribute("data-countdown")
      ).getTime(),
      second = 1000,
      minute = second * 60,
      hour = minute * 60,
      day = hour * 24;
    const countDownInterval = setInterval(function () {
      let currentTime = new Date().getTime(),
        timeDistance = date - currentTime,
        daysValue = Math.floor(timeDistance / day),
        hoursValue = Math.floor((timeDistance % day) / hour),
        minutesValue = Math.floor((timeDistance % hour) / minute),
        secondsValue = Math.floor((timeDistance % minute) / second);

      CountDownElement.innerHTML =
        countDownItem(daysValue, window.countdown.days) +
        countDownItem(hoursValue, window.countdown.Hours) +
        countDownItem(minutesValue, window.countdown.minutes) +
        countDownItem(secondsValue, window.countdown.second);

      if (timeDistance < 0) clearInterval(countDownInterval);
    }, 1000);
  }
}
customElements.define("countdown-timer", DataCountdown);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("[grid-recommendation]");
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.querySelector("[grid-recommendation]").innerHTML =
              recommendations.innerHTML;
          }

          if (recommendations) {
            if (recommendations.innerHTML.trim().length === 0) {
              this.parentElement.classList.add("no-js-inline");
            } else {
              this.children[0].classList.remove("no-js-inline");
            }
          }

          if (html.querySelector(".product-grid-item")) {
            this.classList.add("product-recommendations--loaded");
          }

          if (this.dataset.intent == "complementary") {
            let complementaryProducts = new Swiper(
              this.querySelector(".complementory--slider"),
              {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 15,
                autoHeight: true,
                pagination: {
                  el: this.querySelector(".swiper-pagination"),
                  clickable: true,
                },
                navigation: {
                  nextEl: this.querySelector(".swiper-button-next"),
                  prevEl: this.querySelector(".swiper-button-prev"),
                },
              }
            );
            this.querySelector(
              ".complementary-slideshow--slider"
            ).classList.remove("no-js-inline");

            this.querySelector("details")
              ? (this.querySelector("details").open = true)
              : null;
          }

          if (this.dataset.intent == "related") {
            let autoplay = false,
              sliderAutoplay = this.dataset.autoplay,
              autoPlayValue = false,
              autoPlayTime = parseInt(this.dataset.autoplayTime),
              sliderContainer = true;
            if (sliderAutoplay == "true") {
              autoPlayValue = {
                delay: autoPlayTime,
              };
            }
            if (this.dataset.sliderEnable !== "true") {
              sliderContainer = false;
            }

            let relatedProducts = new Swiper(
              this.querySelector(".productSlider"),
              {
                loop: true,
                slidesPerView: parseInt(this.dataset.showMobile),
                spaceBetween: 30,
                autoplay: autoPlayValue,
                pagination: {
                  el: this.querySelector(".swiper-pagination"),
                  clickable: true,
                  type: "fraction",
                },
                navigation: {
                  nextEl: this.querySelector(".swiper-button-next"),
                  prevEl: this.querySelector(".swiper-button-prev"),
                },
                breakpoints: {
                  640: {
                    slidesPerView: parseInt(this.dataset.showMobile),
                  },
                  750: {
                    slidesPerView: parseInt(this.dataset.showMobile),
                  },
                  992: {
                    slidesPerView: parseInt(this.dataset.showExtraLarge),
                  },
                },
              }
            );

            if (sliderContainer && sliderAutoplay == "true") {
              this.querySelector(".productSlider").addEventListener(
                "mouseenter",
                (e) => {
                  relatedProducts.autoplay.stop();
                }
              );
              this.querySelector(".productSlider").addEventListener(
                "mouseleave",
                (e) => {
                  relatedProducts.autoplay.start();
                }
              );
            }

            // Slide thumbnail height
            const slideThumbHeight = () => {
              const proudctThumbnails = this.querySelector(
                ".productSlider"
              ).querySelectorAll(".card--client-height");
              if (proudctThumbnails.length > 0) {
                const productThumbnailHeight = proudctThumbnails[0];
                this.querySelector(
                  ".productSlider"
                ).parentElement.style.setProperty(
                  "--slider-navigation-top-offset",
                  `${productThumbnailHeight.clientHeight / 2}px`
                );
              }
            };
            slideThumbHeight();
            window.addEventListener("resize", () => {
              slideThumbHeight();
            });
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);


var lastURL = document.referrer;
var currentURL = window.location.href;
localStorage.setItem('lastURL', lastURL);
localStorage.setItem('currentURL', currentURL);

var storedLastURL = localStorage.getItem('lastURL');
var lasturl_split = storedLastURL.split('?')[0];
console.log("lasturl_split",lasturl_split)
var storedCurrentURL = localStorage.getItem('currentURL');
var CurrentURL_split = storedLastURL.split('?')[0];
console.log("CurrentURL_split",CurrentURL_split)
console.log("Stored Last URL: " + storedLastURL);
console.log("Stored Current URL: " + storedCurrentURL);
if(lasturl_split == CurrentURL_split){
  localStorage.setItem('sortrefresh', 'True');
}
else{
  localStorage.setItem('sortrefresh', 'False');
}

// Desktop Submenu Toggle
var Store_menu = [];
let Parent_menu = document.querySelectorAll('.header__mega_menu--inner .header__mega_menu_li');
// console.log("Parent_menu", Parent_menu);
Store_menu.push(...Parent_menu);
// console.log("Store_menu", Store_menu);
Parent_menu.forEach((menuItem, index) => {
    // Add class based on index
    menuItem.classList.add(`parent_menu-${index}`);
});

Store_menu.forEach((menuItem, menuIndex) => {
  let subMenus = menuItem.querySelectorAll('.header__mega_sub_menu .header__mega_sub_menu_li');
  subMenus.forEach((subMenu, subMenuIndex) => {
      subMenu.classList.add(`sub_menu-${subMenuIndex}`);
      if (subMenuIndex < 4) {
          subMenu.style.display = 'block';
      } else {
          subMenu.style.display = 'none';
      }
  });

  if (subMenus.length > 4) {
    var div_desktop = document.createElement("div");
    div_desktop.classList.add("desktop_menu_toggle-btn_wrapper");
      let pTag = document.createElement('p');
      pTag.innerText = 'Show More';
      pTag.classList.add(`sub_menu_toggle-${menuIndex}`);
      pTag.classList.add(`menu_toggle-btn`)
      div_desktop.appendChild(pTag);
      let megaSubMenu = menuItem.querySelector('.header__mega_sub_menu');
      if (megaSubMenu) {
          megaSubMenu.appendChild(div_desktop);
      }
  }
});

var desktop_submenu_btn = document.querySelectorAll('.menu_toggle-btn');
desktop_submenu_btn.forEach(function(btn) {

  btn.addEventListener('click', function(event) {
    var clickedElementClass = event.currentTarget.className;
    console.log('Clicked element class:', clickedElementClass);
    if(clickedElementClass.includes('sub_menu_toggle-')){
      var classListArray = clickedElementClass.split(' ');
      var matchedClass = classListArray.find(function(cls) {
        return cls.startsWith('sub_menu_toggle-');
      });
      if (matchedClass) { 
        var splittedClass = matchedClass.split('-')[1];
        console.log('The clicked split', splittedClass);
        var get_parent_menu =document.querySelector(".parent_menu-"+splittedClass);
        var header__mega_sub_menu = get_parent_menu.querySelector(".header__mega_sub_menu");
        var header__mega_sub_menu_li = header__mega_sub_menu.querySelectorAll("li");
        if (event.currentTarget.innerHTML == 'Show Less') {
          console.log("The button text is  'Show More'");
          var change_innertext = document.querySelector(".sub_menu_toggle-"+splittedClass);
          change_innertext.innerHTML = 'Show More';
          header__mega_sub_menu_li.forEach(function(li, index) {
            if (index < 4) { 
                li.style.display = 'block';
            } else {
                li.style.display = 'none'; 
            }
        });
        } else {
          console.log("The button text is  'Hide All'");
          var change_innertext = document.querySelector(".sub_menu_toggle-"+splittedClass);
          change_innertext.innerHTML = 'Show Less';
          header__mega_sub_menu_li.forEach(function(li) {
            li.style.display = 'block';
        });

        }
        console.log("show element",get_parent_menu)
      } else {
        console.log('No class matching "sub_menu_toggle-" found');
      }
    }
});
});

// Mobile Submenu Toggle
var mobile_Store_menu = [];
let mob_Parent_menu = document.querySelectorAll('.offcanvas__menu_ul .offcanvas__menu_li');
mobile_Store_menu.push(...mob_Parent_menu);
mob_Parent_menu.forEach((menuItem, index) => {
    menuItem.classList.add(`mob_parent_menu-${index}`);
});

mobile_Store_menu.forEach((menuItem, menuIndex) => {
  let mob_subMenus = menuItem.querySelectorAll('.offcanvas__sub_menu .offcanvas__sub_menu_li');
  mob_subMenus.forEach((subMenu, mob_subMenuIndex) => {
    if (menuIndex !== 0) {
      subMenu.classList.add(`mob_sub_menu-${mob_subMenuIndex}`);
  }
  if(menuIndex == 0){
    let mob_sub_main_menu = menuItem.querySelectorAll('.offcanvas__sub_menu');
    mob_sub_main_menu.forEach((subMenu, mob_subMenuIndex) => {
      subMenu.classList.add(`mob_main_sub_menu-${mob_subMenuIndex}`);
      subMenu.classList.add(`mob_main_custom_menu`);
      let subMenuItems = subMenu.querySelectorAll('li ul .offcanvas__sub_menu_li li');
      subMenuItems.forEach((li, index) => {
        if (index < 4) {
          li.style.display = 'block';
      } else {
          li.style.display = 'none';
      }
      })
    })
  }
  })
})




var elements = document.querySelectorAll('[class*="mob_main_sub_menu-"]');

elements.forEach(function(element, index) {
  
    // Check if the class of the element is not mob_main_sub_menu-0
    if (!element.classList.contains('mob_main_sub_menu-0')) {
        // Check if the length of .offcanvas__sub_menu_li is below 4
        if (element.querySelectorAll('.offcanvas__sub_menu_li').length > 4) {
          var divmob = document.createElement("div");
          divmob.classList.add("mob_menu_toggle-btn_wrapper"); 
            var paragraph = document.createElement("p");
            paragraph.innerText = 'Show More';
            paragraph.classList.add(`mob_sub_menu_toggle-${index}`);
            paragraph.classList.add(`mob_menu_toggle-btn`);
            divmob.appendChild(paragraph);
            element.appendChild(divmob);
        }
    }
    
});

var toggleButtons = document.querySelectorAll('.mob_menu_toggle-btn');
toggleButtons.forEach(function(button) {
    button.addEventListener('click', function(event) {
        console.log('Clicked button:', event.target);
        var mob_menu_btn = event.currentTarget.className;
        if(mob_menu_btn.includes('mob_sub_menu_toggle-')){
          var mob_classListArray = mob_menu_btn.split(' ');
          var mob_matchedClass = mob_classListArray.find(function(cls) {
            return cls.startsWith('mob_sub_menu_toggle-');
          });
          if(mob_matchedClass){
            var mob_splittedClass = mob_matchedClass.split('-')[1];
            console.log("mob_splittedClass",mob_splittedClass)
            var mob_get_parent_menu =document.querySelector(".mob_main_sub_menu-"+mob_splittedClass);
            var mob_header__mega_sub_menu_li = mob_get_parent_menu.querySelectorAll("li");
            console.log("Sff",mob_header__mega_sub_menu_li)
            let mobile = document.querySelector(".mob_sub_menu_toggle-" + mob_splittedClass);
            console.log("dfsf",mobile)
            if(mobile.innerText == 'Show Less'){
              mobile.innerText = 'Show More'
              mob_header__mega_sub_menu_li.forEach(function(li, index) {
                if (index < 4) { 
                    li.style.display = 'block';
                } else {
                    li.style.display = 'none'; 
                }
            });
            }else{
              mobile.innerText = 'Show Less'
              var change_innertext = document.querySelector(".mob_sub_menu_toggle-"+mob_splittedClass);
              change_innertext.innerText = 'Show Less';
              mob_header__mega_sub_menu_li.forEach(function(li) {
                li.style.display = 'block';
            });
            }
          }
        }
    });
});

// Preorder function 
const product_swatch = document.querySelectorAll('.product-swatch');

  function handleClick(event) {
    const variantQuantityStr = this.getAttribute('data-variantquantity');
    const cart_name = this.getAttribute('cart-name');
      const NextReleaseDate = this.getAttribute('next-release-date');
     var metafieldTxt = "<strong>Shipping: </strong>" + NextReleaseDate;
    const cart_btn_wrapper = document.querySelector('.product-form__cart--box');
    console.log("cart_btn_wrapper",cart_btn_wrapper)

    const variantQuantity = parseFloat(variantQuantityStr);
        //console.log('Variant Quantity:', variantQuantity);
     var metafield_date = document.querySelector('.metafield-shipping');
          var buttonText = document.querySelector('.button.product-form__submit.button');
          var add_cart_icon = document.getElementById('add-cart-icon');
          const svgElement = add_cart_icon.querySelector('svg');
          const clonedSVG = svgElement.cloneNode(true);

          console.log("svgElement",svgElement)
          setTimeout(function() {
            buttonText.innerHTML = '';
            buttonText.appendChild(clonedSVG);
            const textNode = document.createTextNode(' ' + cart_name);
        buttonText.appendChild(textNode);
            if (NextReleaseDate) {
          if(cart_name != 'Add To Cart'){   
            metafield_date.style.display='block';
          metafield_date.innerHTML = metafieldTxt;
          if (cart_btn_wrapper) {
              cart_btn_wrapper.classList.add('set_preorder');
          }
          }else{
              metafield_date.style.display='none';
          }
          }else{
            metafield_date.innerHTML = '';
               if (cart_btn_wrapper) {
  cart_btn_wrapper.classList.remove('set_preorder');
}     
          }
//console.log("changed")       
           let update_option_price = document?.querySelector('.update-price');
    if(update_option_price){
      const checkedLabel = document.querySelector(
  '.variant--swatch-option1 input[type="radio"]:checked + label:not(.variant--swatch-custom)'
);

if (checkedLabel) {
  const priceElement = checkedLabel.querySelector('.price-with-option');
   const hidePriceElement = document.querySelector('.hide_price');
  if (priceElement && hidePriceElement) {
    priceElement.textContent = hidePriceElement.textContent;
    // console.log('Updated Price Element:', priceElement.textContent);
  } else {
    // console.log('No .price-with-option element found inside label.');
  }
} else {
  // console.log('No matching checked input and label found.');
}

    }    

            
        }, 900);
        }
        product_swatch.forEach(element => {
    element.addEventListener('click', handleClick);
});

// window.onload = function() {
//   const metafieldElement = document.querySelector('.metafield-shipping');
//   if (metafieldElement && metafieldElement.textContent.trim() !== '') {
//     const cartBtnWrapper = document.querySelector('.product-form__cart--box');
//     if (cartBtnWrapper) {
//       cartBtnWrapper.classList.add('set_preorder');
//     }
//   }
// };

document.addEventListener('DOMContentLoaded', function () {
  let update_option_price = document?.querySelector('.update-price');
  
  if (update_option_price) {
    const checkedLabel = document.querySelector(
      '.variant--swatch-option1 input[type="radio"]:checked + label:not(.variant--swatch-custom)'
    );

    if (checkedLabel) {
      const priceElement = checkedLabel.querySelector('.price-with-option');
      const hidePriceElement = document.querySelector('.hide_price');

      if (priceElement && hidePriceElement) {
        priceElement.textContent = hidePriceElement.textContent;
        // console.log('Updated Price Element:', priceElement.textContent);
      } else {
        // console.log('No .price-with-option or .hide_price element found.');
      }
    } else {
      // console.log('No matching checked input and label found.');
    }
  }
});

//CART-SHOWIN-BEHAVIOR________10/10/2025

/* =========================
   CONFIG: section handles
   ========================= */
const CART_SECTIONS = [ 'cart-notification-product', 'cart-notification-discount','cart-notification-count','cart-notification-subtotal','cart-icon-bubble','header-marketplace']; 

/* =========================
   HELPERS
   ========================= */

// Updates the cart count bubble safely.
async function syncCartCount() {
  const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
  const cart = await res.json();
  document.querySelectorAll('[data-cart-count], .cart-count-bubble, #cart-count')
    .forEach(el => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
}

// Re-render drawer + header so the drawer shows the new item immediately. // - AD - REMOVED - 2025/10/31
// async function refreshCartUI(sections = CART_SECTIONS) {
//   const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
//   const res = await fetch(`${root}?sections=${sections.join(',')}`, {
//     headers: { 'X-Requested-With': 'XMLHttpRequest' }
//   });
//   const htmlByHandle = await res.json();

//   sections.forEach(handle => {
//     const mount = document.getElementById(`shopify-section-${handle}`);
//     if (mount && htmlByHandle[handle]) mount.outerHTML = htmlByHandle[handle];
//   });
// }



// ======================================
// CART UI REFRESH with Debug Toggle
// ======================================

// Turn this ON for deep logging, OFF for silence
const DEBUG_MODE = true;

// Split into stable groups that parse fine
const CART_GROUPS = [
  [
    'cart-notification-product',
    'cart-notification-discount',
    'cart-notification-count'
  ],
  [
    'cart-notification-subtotal',
    'cart-icon-bubble',
    'header-marketplace'
  ]
];

async function fetchSectionGroup(sectionGroup) {
  const groupArray = Array.isArray(sectionGroup) ? sectionGroup : [sectionGroup];
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const url = `${root}?sections=${groupArray.join(',')}`;

  try {
    const res = await fetch(url, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });

    if (!res.ok) {
      if (DEBUG_MODE) console.error('❌ Bad status', groupArray, res.status, res.statusText);
      return null;
    }

    const raw = await res.text();

    try {
      const parsed = JSON.parse(raw);
      if (DEBUG_MODE)
        console.log(`✅ Parsed OK for group [${groupArray.join(', ')}]`, Object.keys(parsed));
      return parsed;
    } catch (parseErr) {
      if (DEBUG_MODE)
        console.error(
          '⚠️ JSON parse fail for',
          groupArray,
          parseErr,
          '\nRaw first 300:\n',
          raw.slice(0, 300)
        );
      return null;
    }
  } catch (networkErr) {
    if (DEBUG_MODE) console.error('🌐 Network fail', groupArray, networkErr);
    return null;
  }
}

async function refreshCartUI(groups = CART_GROUPS) {
  try {
    const results = await Promise.all(groups.map(g => fetchSectionGroup(g)));
    const merged = Object.assign({}, ...results.filter(Boolean));

    if (DEBUG_MODE) {
      console.log('🧩 merged keys from Shopify:', Object.keys(merged));
    }

    // 1. Update any full sections returned (standard Shopify pattern)
    Object.keys(merged).forEach(handle => {
      const html = merged[handle];
      if (!html) {
        if (DEBUG_MODE) console.warn(`[SKIP] "${handle}" returned empty html`);
        return;
      }

      const mountId = `shopify-section-${handle}`;
      const mount = document.getElementById(mountId);

      if (DEBUG_MODE) {
        console.log(
          `[PATCH attempt] handle="${handle}"`,
          { mountId, mountFound: !!mount, htmlLength: html.length }
        );
      }

      if (mount) {
        mount.outerHTML = html;
      }
    });

    //
    // 2. Inject cart line items into the open mini cart drawer
    //
    // NOTE: from your HTML, the drawer container is:
    // <div id="cart-notification" class="cart-notification ...">
    // and inside it we ultimately want to refresh:
    //   #cart-notification-product  (the items list area)
    //
    const cartItemsHTML = merged['cart-notification-product'];
    if (cartItemsHTML) {
      // where Shopify sends the new line-items markup
      // Example: <div id="cart-notification-product"> ...line items... </div>

      // find the live cart drawer root
      const cartDrawerRoot = document.querySelector('#cart-notification');
      if (cartDrawerRoot) {
        // find the live items container we want to replace
        const liveItemsNode = cartDrawerRoot.querySelector('#cart-notification-product');
        if (liveItemsNode) {
          // parse returned HTML into a temp element
          const temp = document.createElement('div');
          temp.innerHTML = cartItemsHTML.trim();

          // grab the NEW inner #cart-notification-product from the response
          const newItemsNode = temp.querySelector('#cart-notification-product') || temp;

          // swap
          liveItemsNode.innerHTML = newItemsNode.innerHTML;

          if (DEBUG_MODE) {
            console.log('🎯 UPDATED LINE ITEMS in mini cart', {
              injectedLength: newItemsNode.innerHTML.length
            });
          }

          // also: if you show/hide "Your cart is empty", kill that state now
          const emptyMsgWrapper = cartDrawerRoot.querySelector('.empty__cart__item');
          if (emptyMsgWrapper) {
            emptyMsgWrapper.style.display = newItemsNode.innerHTML.trim().length ? 'none' : '';
          }
        } else if (DEBUG_MODE) {
          console.warn('⚠️ live #cart-notification-product not found in DOM');
        }
      } else if (DEBUG_MODE) {
        console.warn('⚠️ #cart-notification drawer root not found in DOM');
      }
    }

    //
    // 3. Update subtotal / footer totals
    //
    const subtotalHTML = merged['cart-notification-subtotal'];
    if (subtotalHTML) {
      // Your subtotal text lives in:
      // <p id="cart-notification-subtotal">$0.00 USD</p>
      //
      // and all the footer buttons/checkout lives in:
      // <div class="cart-notification__links" id="empty__cart__button"> ... </div>
      //
      const cartDrawerRoot = document.querySelector('#cart-notification');
      if (cartDrawerRoot) {
        const liveSubtotalNode = cartDrawerRoot.querySelector('#cart-notification-subtotal');
        if (liveSubtotalNode) {
          // subtotalHTML coming back from Shopify is usually a full <p>...</p> or fragment.
          const temp = document.createElement('div');
          temp.innerHTML = subtotalHTML.trim();

          // try to grab just the number part if possible
          const newSubtotalNode =
            temp.querySelector('#cart-notification-subtotal') ||
            temp.firstElementChild ||
            temp;

          liveSubtotalNode.innerHTML = newSubtotalNode.innerHTML;

          if (DEBUG_MODE) {
            console.log('💵 UPDATED SUBTOTAL TEXT', {
              newText: liveSubtotalNode.textContent.trim()
            });
          }
        } else if (DEBUG_MODE) {
          console.warn('🪫 #cart-notification-subtotal not found in DOM');
        }

        // if subtotal exists, we should also make sure footer (buttons) is visible
        const footerWrapper = cartDrawerRoot.querySelector('.cart-notification__links');
        if (footerWrapper) {
          footerWrapper.style.display = '';
        }
      }
    }

  } catch (err) {
    if (DEBUG_MODE) console.error('refreshCartUI overall error', err);
  }
}


async function reloadMiniCartDrawer() {
  console.log('[mini-cart] 🔄 reloadMiniCartDrawer() called (JSON mode)');

  try {
    // 1. Get cart JSON
    const cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
    const cartData = await cartRes.json();
    console.log('[mini-cart] 🧠 cartData:', cartData);

    // 2. Build HTML fragments from cartData
    const drawer = document.querySelector('cart-notification');
    if (!drawer) {
      console.warn('[mini-cart] ❌ no cart drawer in DOM');
      return;
    }

    const productContainer = drawer.querySelector('#cart-notification-product');
    const subtotalEl       = drawer.querySelector('#cart-notification-subtotal');
    const footerBlock      = drawer.querySelector('.cart-notification__links'); // has checkout button etc.

    // Rebuild line items markup from cartData.items
    let itemsMarkup = '';
    cartData.items.forEach(item => {
      itemsMarkup += `
        <div class="mini-cart-line-item d-flex gap-10 mb-15">
          <div class="mini-cart-line-item__media" style="width:64px;flex-shrink:0;">
            <img src="${item.image}" alt="${item.title}" style="width:64px;height:auto;display:block;border:1px solid #ddd;border-radius:4px;">
          </div>
          <div class="mini-cart-line-item__info flex-grow-1">
            <a class="mini-cart-line-item__title d-block mb-5" href="${item.url}" style="font-size:1.4rem;line-height:1.2;">
              ${item.product_title || item.title}
            </a>
            <div class="mini-cart-line-item__qty-price d-flex justify-content-between align-items-center" style="font-size:1.3rem;">
              <span class="mini-cart-line-item__qty">Qty: ${item.quantity}</span>
              <span class="mini-cart-line-item__price">${(item.final_line_price / 100).toLocaleString('en-US', {style:'currency', currency:cartData.currency})}</span>
            </div>
          </div>
        </div>`;
    });

    // inject items
    if (productContainer) {
      productContainer.innerHTML = itemsMarkup;
    } else {
      console.warn('[mini-cart] ❌ no #cart-notification-product');
    }

    // inject subtotal
    if (subtotalEl) {
      subtotalEl.textContent = (cartData.total_price / 100).toLocaleString('en-US', {
        style: 'currency',
        currency: cartData.currency
      });
    }

 // 3. Force visibility state AFTER injecting new markup
(function enforceMiniCartVisibilityHard() {
  const drawer         = document.querySelector('cart-notification');
  const emptyBlock     = drawer?.querySelector('.empty__cart__item');
  const itemsWrapper   = drawer?.querySelector('#min-cart-items'); // .cart__items
  const footerBlock    = drawer?.querySelector('#empty__cart__button'); // .cart-notification__links
  const productSlot    = drawer?.querySelector('#cart-notification-product');
  const subtotalEl     = drawer?.querySelector('#cart-notification-subtotal');

  const hasItemsNow = Array.isArray(cartData.items) && cartData.items.length > 0;

  console.log('[mini-cart] 👁 HARD visibility pass. hasItemsNow:', hasItemsNow, {
    emptyBlock,
    itemsWrapper,
    footerBlock,
    productSlot,
    subtotalText: subtotalEl?.textContent
  });

  // Helper: aggressively unhide block
  function showForce(el, label) {
    if (!el) return;
    el.style.removeProperty('display');
    el.style.setProperty('display', 'block', 'important');
    el.style.removeProperty('visibility');
    el.style.setProperty('visibility', 'visible', 'important');
    el.style.removeProperty('opacity');
    el.style.setProperty('opacity', '1', 'important');
    el.removeAttribute('hidden');
    el.setAttribute('aria-hidden', 'false');

    // strip possible "no-js-inline" junk that might mess layout
    el.classList.remove('no-js-inline', 'is-hidden', 'hidden', 'visually-hidden');

    console.log(`[mini-cart] 🔓 forced SHOW on ${label}`, el);
  }

  // Helper: aggressively hide block
  function hideForce(el, label) {
    if (!el) return;
    el.style.setProperty('display', 'none', 'important');
    el.setAttribute('aria-hidden', 'true');
    console.log(`[mini-cart] 🔒 forced HIDE on ${label}`, el);
  }

  // Drawer itself: mark drawer non-empty
  if (drawer) {
    if (hasItemsNow) {
      drawer.classList.remove('is-empty', 'empty', 'cart-empty');
      drawer.setAttribute('data-has-items', 'true');
    } else {
      drawer.classList.add('is-empty');
      drawer.setAttribute('data-has-items', 'false');
    }
  }

  if (hasItemsNow) {
    // hide "your cart is empty"
    hideForce(emptyBlock, 'emptyBlock');

    // show product list wrapper
    showForce(itemsWrapper, 'itemsWrapper');

    // show footer (subtotal / checkout)
    showForce(footerBlock, 'footerBlock');

    // ALSO show the actual product slot explicitly
    showForce(productSlot, 'productSlot');
  } else {
    // cart is empty
    showForce(emptyBlock, 'emptyBlock');
    hideForce(itemsWrapper, 'itemsWrapper');
    hideForce(footerBlock, 'footerBlock');
    hideForce(productSlot, 'productSlot');
  }

  // Sanity snapshot after forcing
  console.log('[mini-cart] 🧪 POST-FORCE SNAPSHOT >>>');
  console.log(' emptyBlock styles:', emptyBlock && {
    display: emptyBlock.style.display,
    visibility: emptyBlock.style.visibility,
    opacity: emptyBlock.style.opacity,
    ariaHidden: emptyBlock.getAttribute('aria-hidden')
  });
  console.log(' itemsWrapper styles:', itemsWrapper && {
    display: itemsWrapper.style.display,
    visibility: itemsWrapper.style.visibility,
    opacity: itemsWrapper.style.opacity,
    ariaHidden: itemsWrapper.getAttribute('aria-hidden'),
    classList: itemsWrapper.className
  });
  console.log(' footerBlock styles:', footerBlock && {
    display: footerBlock.style.display,
    visibility: footerBlock.style.visibility,
    opacity: footerBlock.style.opacity,
    ariaHidden: footerBlock.getAttribute('aria-hidden'),
    classList: footerBlock.className
  });
  console.log(' productSlot styles:', productSlot && {
    display: productSlot.style.display,
    visibility: productSlot.style.visibility,
    opacity: productSlot.style.opacity,
    ariaHidden: productSlot.getAttribute('aria-hidden')
  });
  console.log('[mini-cart] 🧪 <<< SNAPSHOT END');
})();

    console.log('[mini-cart] ✅ refresh complete (JSON mode). hasItemsNow:', cartData.items.length > 0, 'items:', cartData.items.length);

  } catch (err) {
    console.error('[mini-cart] 💥 reloadMiniCartDrawer error:', err);
  }
}





/* =========================
   MAIN HANDLER (Grid + PDP)
   ========================= */

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-ajax-add]');
  if (!btn || btn.disabled) return;

  e.preventDefault();
  btn.disabled = true;

  try {
    // Build the request body from either the PDP form or a grid variant id
    let body;
    const formSel = btn.getAttribute('data-form');
    if (formSel) {
      // PDP path: include id, quantity, properties, selling_plan, etc.
      const form = document.querySelector(formSel);
      if (!form) throw new Error('Product form not found');
      body = new FormData(form);
    } else if (btn.hasAttribute('data-variant-id')) {
      // Grid path: minimal add
      body = new FormData();
      body.append('id', btn.getAttribute('data-variant-id'));
      body.append('quantity', '1');
    } else {
      return; // nothing to do
    }

    // Add silently (no drawer open)
    const addRes = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body
    });
    if (!addRes.ok) throw await addRes.json();

    // update the count bubble immediately
    await syncCartCount();

    // re-render drawer + header HTML so the drawer content is fresh (but stays closed)
    //await refreshCartUI(CART_SECTIONS); - AD Removed - 2025-10-31
    await refreshCartUI();
    await reloadMiniCartDrawer();

  } catch (err) {
    console.error('Add to cart failed', err);
  } finally {
    btn.disabled = false;
  }
});

/* =========================
   KEEP THINGS IN SYNC AFTER CHANGES/REMOVALS
   ========================= */

// When user changes/removes items inside the drawer, refresh drawer + header afterward.
// We don't block the theme submit; we just sync the UI right after it runs.
document.addEventListener('submit', (e) => {
  const drawerForm = e.target.closest(
      '[id^="shopify-section-cart-notification-"] form[action*="/cart/"],' +
    '#shopify-section-cart-icon-bubble form[action*="/cart/"]'
  );
  if (!drawerForm) return;
  // Let the theme handle the request first, then refresh sections.
  // setTimeout(() => refreshCartUI(CART_SECTIONS), 0);  - AD Removed - 2025-10-31
  setTimeout(() => refreshCartUI(), 0);
});

// (FIX B2) If user navigates back (bfcache), the bubble can be stale; resync it.
window.addEventListener('pageshow', (e) => {
  if (e.persisted) syncCartCount();
});




